import Button from '@mui/joy/Button'
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp'

export const LayerUpButton = ({ onClick }) => (
    <Button
        variant="soft"
        color="neutral"
        onClick={onClick}
        startDecorator={<KeyboardArrowUp />}
    >
        Up
    </Button>
)
